// src/services/CommentAdminService.js

import http from "./httpService";

class FormSubmissionAdminService {
  async getAll(params) {
    const url = http.getUrlWithParams("/admin/formsubmission", params);
    return await http.get(url);
  }
}

export default new FormSubmissionAdminService();
